export default __webpack_public_path__ + "static/media/storedge_logo.ae560307.png";